import { createSlice } from '@reduxjs/toolkit';

export const reportsSlice = createSlice({
    name: "reports",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const reportsActions = reportsSlice.actions;

export default reportsSlice.reducer;